/* import __COLOCATED_TEMPLATE__ from './posting-create-details.hbs'; */
import { readOnly, alias, equal, or } from '@ember/object/computed';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { POSTING_CREATE_USE_KEY_DATES, KEY_DATES_OPTIONS } from 'sh-www/constants/routes/posting-create';

const CLASS_NAME = 'SH-c-posting-create-details';

export default Component.extend({
  /**
   * HTML Component properties
   */
  tagName: '',
  CLASS_NAME,

  /**
   * Register services
   */
  state: service('states/routes/posting-create'),
  stateManager: service('state-managers/routes/posting-create'),

  /**
   * @type {Boolean}    True when the form elements should be disabled
   */
  _areFormElementsDisabled: readOnly('state.areFormElementsDisabled'),

  /**
   * @type {String}   of type POSTING_CREATE_USE_KEY_DATES.*
   */
  _updatedHasKeyDates: readOnly('state.updatedHasKeyDates'),

  /**
   * @type {Array<AssignmentSchedule>}
   */
  _updatedScheduleItems: readOnly('state.updatedScheduleItems'),

  /**
   * @type {Object}
   */
  _scheduleErrors: computed('state.errors', function () {
    return Object.entries(this.state.errors).reduce((accum, [errorKey, errorValues]) => {
      if (errorKey.startsWith('schedule') && errorValues) {
        const index = errorKey.split('.')[1];

        // 'schedule' handled below input
        if (index === undefined) {
          return accum;
        }

        // yup or server error
        const errorString = Array.isArray(errorValues)
          ? errorValues.join('. ')
          : errorValues;

        const errorAtIndex = accum[index];

        const combinedErrorString = errorAtIndex
          ? `${errorAtIndex}. ${errorString}`
          : errorString;

        // ensure correct punctuation
        accum[index] = combinedErrorString.replace(/\.{2,}/g, '.');
      }

      return accum;
    }, {});
  }),

  /**
   * @type {String}   of type POSTING_CREATE_USE_KEY_DATES.*
   */
  _showExamples: or('state.updatedExamplesExplictlyShown', 'state.updatedExamples'),

  /**
   * @type {Array<Object>}    Dropdown options for schedule item type
   */
  _keyDatesDropdownOptions: KEY_DATES_OPTIONS,

  /**
   * @type {Number}    Enum for POSTING_CREATE_USE_KEY_DATES.*
   */
  _isHasKeyDatesNo: POSTING_CREATE_USE_KEY_DATES.NO,
  _isHasKeyDatesYes: POSTING_CREATE_USE_KEY_DATES.YES,

  /**
   * @type {Boolean}    True when they select that there are key dates
   */
  _isHasKeyDatesNoSelected: equal('_updatedHasKeyDates', POSTING_CREATE_USE_KEY_DATES.NO),
  _isHasKeyDatesYesSelected: equal('_updatedHasKeyDates', POSTING_CREATE_USE_KEY_DATES.YES),

  /**
   * NOTE - THESE ARE ALIASED WITH THE ROUTE LEVEL STATE
   *
   * @type {String}   These are the updated values for the text areas
   */
  _updatedDeliverables: alias('state.updatedDeliverables'),
  _updatedDescription: alias('state.updatedDescription'),
  _updatedExamples: alias('state.updatedExamples'),

  actions: {
    handleDescriptionChange() {
      this.set('state.errors', {
        ...this.state.errors,
        description: undefined,
      });
    },

    handleExamplesChange() {
      this.set('state.errors', {
        ...this.state.errors,
        examples: undefined,
      });
    },

    handleDeliverablesUpdate(deliverables) {
      this.set('state.errors', {
        ...this.state.errors,
        assignment_deliverables: undefined,
      });

      this.stateManager.updateAssignmentDeliverables(deliverables);
    },

    handleExamplesExplictlyShow() {
      this.stateManager.updateExamplesExplictlyShown(true);
    },

    handleScheduleUpdate(schedule) {
      // clear related errors
      const errorsToClear = Object.entries(this.state.errors).reduce((accum, [errorKey, errorValues]) => {
        if (errorKey.startsWith('schedule') && errorValues) {
          accum[errorKey] = undefined;
        }

        return accum;
      }, {});

      this.set('state.errors', {
        ...this.state.errors,
        ...errorsToClear,
      });

      this.stateManager.updateAssignmentScheduleItems(schedule);
    },

    handleUseKeyDates(useKeyDates) {
      this.set('state.errors', {
        ...this.state.errors,
        schedule: undefined,
      });

      this.stateManager.updateHasKeyDates(useKeyDates);
    },
  },
});
